export default __webpack_public_path__ + "static/media/gp-img.cdb0d070.webp";